import React from 'react';
import { Form, DatePicker as AntdDatePicker } from 'antd';
import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/lv';
import type { NoUndefinedRangeValueType } from 'rc-picker/lib/PickerInput/RangePicker';
import lv_LV from 'antd/es/date-picker/locale/lv_LV';
import {PickerLocale} from "antd/es/date-picker/generatePicker";
import { Validations } from '../../interfaces';
import useFormValidation from '../../utils/useFormValidation';

const { RangePicker: AntdRangePicker } = AntdDatePicker;

dayjs.locale('lv');

export interface RangePickerProps extends Validations {
  size?: 'large' | 'middle' | 'small';
  placeholder?: [string, string];
  onChange?: (dates: NoUndefinedRangeValueType<Dayjs> | null, dateStrings: [string, string]) => void;
  disabled?: boolean;
  value?: [Dayjs, Dayjs];
  picker?: any;
  format?: string | string[];
  name?: string | undefined;
  label?: string;
  disabledDate?: (date: Dayjs) => boolean;
  initialValue?: [Dayjs, Dayjs];
  className?: string;
  suffixIcon?: JSX.Element | [JSX.Element, JSX.Element];
}

interface AntdRangePickerProps extends RangePickerProps {
  getPopupContainer: (triggerNode: HTMLElement) => HTMLElement;
  locale: PickerLocale;
}

export const RangePicker = ({
  className,
  placeholder = ['', ''],
  onChange,
  disabled,
  validations,
  value,
  size = 'large',
  picker,
  format = 'DD.MM.YYYY',
  name,
  label,
  disabledDate,
  initialValue,
  suffixIcon,
}: RangePickerProps) => {
  const { formValidations } = useFormValidation();
  const rules = validations ? formValidations(validations) : [];

  const pickerProps: AntdRangePickerProps = {
    className,
    getPopupContainer: (triggerNode: HTMLElement) => triggerNode,
    placeholder,
    onChange,
    disabled,
    value,
    size,
    format,
    picker,
    disabledDate,
    locale: lv_LV,
  };

  if (suffixIcon !== undefined) {
    pickerProps.suffixIcon = suffixIcon;
  }

  return (
    <Form.Item
      name={name}
      label={label}
      initialValue={initialValue}
      rules={rules}
    >
      <AntdRangePicker {...pickerProps} />
    </Form.Item>
  );
};